import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  fullWidth: {
    width: "100%",
  },
  paper: {
    maxHeight: "100vh",
    height: "100vh",
  },
  root: {
    margin: 0,
    // marginLeft: -8,
    borderRadius: 0,
    marginTop: 50,
  },
  btn: {
    textTransform: "capitalize",
  },
  hero: {
    objectFit: "cover",
    width: "100%",
    // height: 200,
  },
  wrapHeader: {
    // textAlign: "center",
    marginLeft: "20px",
    marginTop: "70px",
  },
  liquidTitle: {
    fontWeight: "bold",
    color: theme.palette.textColor.primeTextColor,
  },
  liquidBold: {
    fontSize: 16,
    marginLeft: "1.5%",
    fontWeight: "bold",
  },
  liquidPrimary: {
    fontSize: 14,
  },
  liquidPrimaryCa: {
    fontSize: 14,
    textTransform: "capitalize",
  },
  liquidSecond: {
    fontSize: 14,
    color: theme.palette.textColor.gray,
  },
  liquidSecondCa: {
    fontSize: 13,
    textTransform: "capitalize",
  },
  liquidBlue: {
    fontSize: 13,
    textTransform: "capitalize",
    color: "#587CD4",
  },
  liquidSecondList: {
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  liquidThird: {
    fontSize: 12,
    color: theme.palette.primary.main,
  },
  liquidWa: {
    fontSize: 12,
    color: "#4DC897",
  },
  liquidOrange: {
    fontSize: 13,
    color: "#FDB429",
    textTransform: "capitalize",
  },
  secondItem: {
    marginTop: "20px",
  },
  wrapBtnList: {
    display: "flex",
    justifyContent: "center",
  },
  wrapList: {
    marginTop: "90px",
  },
  wrapItem: {
    // padding: "15px",
    textAlign: "center",
    // backgroundColor: "#5675D3",
    borderRadius: "10px",
    // marginLeft: "20px",
    marginRight: "20px",
    // boxShadow: "0px 5px 10px #42424359",
    // "@media (max-width: 480px)": {
    //   height: "125px",
    // },
  },
  medium: {
    width: 40,
    height: 40,
    backgroundColor: "lightgray",
    // border: "2px solid #FFFFFF",
    // "@media (max-width: 768px)": {
    //   width: 40,
    //   height: 40,
    // },
    // "@media (max-width: 480px)": {
    //   width: 40,
    //   height: 40,
    // },
  },
  accordion: {
    // position: "relative",
    backgroundColor: "#FEFEFE",
    "&::before": {
      height: 0,
    },
  },
  // expanded: {
  //   margin: "0 !important",
  // },
}));

export default useStyles;
